import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Text } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';

interface RemoveJudgingModalProps {
  isModalOpen: boolean;
  onDismissModal(): void;
  onRemoveAndContinueButtonClicked(): void;
  onRemoveAndExitButtonClicked(): void;
  isHideContinueButton: boolean;
}

const RemoveJudgingModalImpl: React.FC<RemoveJudgingModalProps> = (props) => {
  const {
    isModalOpen,
    onDismissModal,
    onRemoveAndContinueButtonClicked,
    onRemoveAndExitButtonClicked,
    isHideContinueButton,
  } = props;

  const commonStyles = useCommonStyles();

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) onDismissModal();
      }}
    >
      <DialogSurface className={commonStyles.modalSurface}>
        <DialogBody className={commonStyles.modalBody}>
          <DialogTitle
            action={<Button
              appearance='transparent'
              title='Close'
              icon={<DismissRegular />}
              onClick={onDismissModal}
            />}
          >
            Remove nomination
          </DialogTitle>
          <DialogContent>
            <Text as='p'>
              Please note that once the nomination is removed, you will not be able to return to this nomination unless it is assigned to you at a later date.
            </Text>
          </DialogContent>
          <DialogActions fluid>
            <Button
              appearance='secondary'
              onClick={() => onDismissModal()}
            >
              Back
            </Button>
            <Button
              appearance='primary'
              onClick={() => onRemoveAndExitButtonClicked()}
            >
              Remove & exit
            </Button>
            {
              !isHideContinueButton &&
              <Button
                appearance='primary'
                onClick={() => onRemoveAndContinueButtonClicked()}
              >
                Remove & continue
              </Button>
            }
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const RemoveJudgingModal = observer(RemoveJudgingModalImpl);
